import React, { useState, useEffect, useRef } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { es } from 'date-fns/locale';
import './custom-datepicker.scss';

const CustomInput = React.forwardRef(({ value, onClick, onChange, handleFocus, handleBlur }, ref) => {
  return (
    <div className='static-text-field form-group'>
      <input 
        type="text"
        className="custom-datepicker form-input"
        value={value || ''}
        onClick={onClick}
        onChange={onChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        ref={ref}
      />
      <div className="calendar_icon" onClick={onClick}></div>
    </div>
  );
});

const DatePickerComponent = ({ onDateChange, inputLabel, inputField }) => {
  const [startDate, setStartDate] = useState(null);
  const [isFocused, setIsFocused] = useState(false);
  const [val, setVal] = useState(inputField);

  const datePickerRef = useRef(null);

  const handleDateChange = (date) => {
    setStartDate(date);
    if (onDateChange) {
      onDateChange(date);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;

    if (value === '') {
      setStartDate(null);
    } else {
      const parsedDate = new Date(value);
      if (!isNaN(parsedDate)) {
        setStartDate(parsedDate);
      } else {
        setStartDate(null);
      }
    }
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = (event) => {
    val ? setIsFocused(true): setIsFocused(false);
  };

  useEffect(() => {
    setVal(inputField);
  }, [inputField]);

  useEffect(() => {
    if (val) {
        setIsFocused(true)
    } else {
        setIsFocused(false)
    }
  }, [val]);

  const handleCalendarClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  return (
    <div className={`form-group datepicker-container ${isFocused ? "focused" : ""}`}>
      <label className="form-label">
        {inputLabel}
      </label>
      <DatePicker
        ref={datePickerRef}
        selected={startDate}
        onChange={handleDateChange}
        dateFormat="yyyy-MM-dd"
        locale={es}
        customInput={
          <CustomInput 
            value={startDate ? startDate.toISOString().split('T')[0] : ''}
            onClick={handleCalendarClick}
            onChange={handleInputChange}
            inputLabel={inputLabel}
            handleBlur={handleBlur}
            handleFocus={handleFocus}
          />
        }
        minDate={new Date()}
      />
    </div>
  );
};

export default DatePickerComponent;
